export default __webpack_public_path__ + "static/media/count_down.93410add.mp3";